import $ from 'jquery';

const showSuggestion = ($el, results) => {
    const $autocomplete = $('.js-autocomplete div ul');
    const $div = $el.closest('div');
    const $ul = $('<ul></ul>');
    const $li = $('<li><a href="#"></a></li>');

    $autocomplete.remove();
    if (results.length === 0) return;

    for (let i = 0; i < results.length; i += 1) {
        const $item = $li.clone();
        $item.find('a').text(results[i]);
        $ul.append($item);
    }

    $div.append($ul);
    $ul.find('li a').click(function (e) {
        e.preventDefault();
        $el.val($(this).text());
        $div.find('ul').remove();
    });
};

const apiRequest = $el => {
    $el.keyup(() => {
        $.get(`${$el.data('api-url')}${$el.val()}`)
            .done(results => {
                showSuggestion($el, results);
            });
    });

    // hide suggestion on blur
    $('body').on('keyup click', () => {
        if ($(':focus').closest('.js-autocomplete').length === 0) {
            $('.js-autocomplete div ul').remove();
        }
    });
};

const initAutocomplete = () => {
    const $els = $('.js-autocomplete input');
    if ($els.length === 0) return;

    $els
        .attr('autocomplete', 'new-password')
        .each(function () {
            const $el = $(this);
            $el.wrap('<div class="autocomplete-wrapper"></div>');
            apiRequest($el);
        });
};

$(() => {
    initAutocomplete();
});
